﻿export const articles = [
  {
    "id": "divine-synthesis",
    "slug": {
      "en": "divine-synthesis",
      "es": "divine-synthesis",
      "nl": "divine-synthesis",
      "pap": "divine-synthesis"
    },
    "title": {
      "en": "Divine Synthesis",
      "es": "Síntesis Divina",
      "nl": "Goddelijke Synthese",
      "pap": "Síntesis Divino"
    },
    "author": "Eduard",
    "date": "2021-03-28",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "In this article, an attempt is made to guide the mind to think about the unity of the Divine. The Divine is expressed in the world through many, here we focus our attention and synthesize the Divine back to One.",
      "es": "En este artículo se intenta guiar la mente a reflexionar sobre la unidad de lo Divino. Lo Divino se expresa en el mundo a través de lo múltiple; aquí enfocamos nuestra atención y sintetizamos lo Divino de nuevo en lo Uno.",
      "nl": "In dit artikel wordt geprobeerd de geest te leiden naar nadenken over de eenheid van het Goddelijke. Het Goddelijke komt in de wereld tot uitdrukking via het vele; hier richten we onze aandacht en brengen het Goddelijke terug tot het Ene.",
      "pap": "Den e artíkulo aki ta purba guia e mente pa pensa riba e unidat di e Divino. E Divino ta ekspresá su mes den mundu via hopi; akinan nos ta enfoká nos atenshon i sintetisá e Divino bèk na Un."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/Divine Synthesis.pdf#toolbar=0",
      "es": "./articles/Divine Synthesis_ES.pdf#toolbar=0",
      "nl": "./articles/Divine Synthesis_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/synthesis.jpg",
    "imageAlt": "Divine Synthesis - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-2.html",
      "sourceLine": 191,
      "metaText": "By Eduard / 28 March 2021 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "In this article, an attempt is made to guide the mind to think about the unity of the Divine. The Divine is expressed in the world through many, here we focus our attention and synthesize the Divine back to One.",
      "image": "images/synthesis.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "universal-base-directives-the-three-pillars",
    "slug": {
      "en": "universal-base-directives-the-three-pillars",
      "es": "universal-base-directives-the-three-pillars",
      "nl": "universal-base-directives-the-three-pillars",
      "pap": "universal-base-directives-the-three-pillars"
    },
    "title": {
      "en": "Universal Base Directives: The Three Pillars",
      "es": "Directrices Base Universales: Los Tres Pilares",
      "nl": "Universele Basisrichtlijnen: De Drie Pijlers",
      "pap": "Direktivanan Base Universal: E Tres Pilarnan"
    },
    "author": "Eduard",
    "date": "2021-07-06",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "The three pillars of the Universal Base Directives is presented here for all sentient beings, human and non-human, to read and understand. The importance of respecting these pillars is stressed in order to restore and create a more cohesive or unifying Universe.",
      "es": "Aquí se presentan los tres pilares de las Directrices Base Universales para que todos los seres sintientes, humanos y no humanos, los lean y comprendan. Se subraya la importancia de respetar estos pilares para restaurar y crear un Universo más cohesionado y unificador.",
      "nl": "Hier worden de drie pijlers van de Universele Basisrichtlijnen gepresenteerd, zodat alle bewuste wezens, menselijk en niet-menselijk, ze kunnen lezen en begrijpen. Het belang van het respecteren van deze pijlers wordt benadrukt om een samenhangender en verenigend Universum te herstellen en te scheppen.",
      "pap": "Akinan ta presentá e tres pilarnan di e Direktivanan Base Universal pa tur ser konsiente, humano i no-humano, lesa i komprondé. Ta enfatisá e importansia di respetá e pilarnan aki pa restorá i krea un Universo mas koheso i unifikadó."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/Universal Base Directives.pdf#toolbar=0",
      "es": "./articles/Universal Base Directives_ES.pdf#toolbar=0",
      "nl": "./articles/Universal Base Directives_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/directives.jpg",
    "imageAlt": "Universal Base Directives: The Three Pillars - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-2.html",
      "sourceLine": 205,
      "metaText": "By Eduard / 06 Jul 2021 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "The three pillars of the Universal Base Directives is presented here for all sentient beings, human and non-human, to read and understand. The importance of respecting these pillars is stressed in order to restore and create a more cohesive or unifying Universe.",
      "image": "images/directives.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "to-live-is-to-die-to-die-is-to-be-reborn",
    "slug": {
      "en": "to-live-is-to-die-to-die-is-to-be-reborn",
      "es": "to-live-is-to-die-to-die-is-to-be-reborn",
      "nl": "to-live-is-to-die-to-die-is-to-be-reborn",
      "pap": "to-live-is-to-die-to-die-is-to-be-reborn"
    },
    "title": {
      "en": "To Live is to Die, to Die is to be Reborn",
      "es": "Vivir es Morir, Morir es Renacer",
      "nl": "Leven is Sterven, Sterven is Herboren Worden",
      "pap": "Biba ta Muri, Muri ta Nase di Nobo"
    },
    "author": "Eduard",
    "date": "2021-10-14",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "This article is an alchemical love letter to Divinity. It is plainly written, yet only those who do their homework will be able to decipher it.",
      "es": "Este artículo es una carta de amor alquímica a la Divinidad. Está escrito con sencillez, pero solo quienes hagan su tarea podrán descifrarlo.",
      "nl": "Dit artikel is een alchemistische liefdesbrief aan het Goddelijke. Het is eenvoudig geschreven, maar alleen wie zijn huiswerk doet, zal het kunnen ontcijferen.",
      "pap": "E artíkulo aki ta un karta di amor alkímiko na e Divinidat. E ta skirbí simpel, pero solamente esnan ku hasi nan tarea lo por dekodifiká e."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/To Live is to Die.pdf#toolbar=0",
      "es": "./articles/To Live is to Die_ES.pdf#toolbar=0",
      "nl": "./articles/To Live is to Die_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/alchemy.png",
    "imageAlt": "To Live is to Die, to Die is to be Reborn - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-2.html",
      "sourceLine": 219,
      "metaText": "By Eduard / 14 Oct 2021 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "This article is an alchemical love letter to Divinity. It is plainly written, yet only those who do their homework will be able to decipher it.",
      "image": "images/alchemy.png"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "mjolnir",
    "slug": {
      "en": "mjolnir",
      "es": "mjolnir",
      "nl": "mjolnir",
      "pap": "mjolnir"
    },
    "title": {
      "en": "Mjölnir",
      "es": "Mjölnir",
      "nl": "Mjölnir",
      "pap": "Mjölnir"
    },
    "author": "Eduard",
    "date": "2021-12-31",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "This article is a little summary of the famous Mjölnir. This symbol is also used in the The Great Work Experience logo. It is a dear symbol for all those who cherish and love Truth.",
      "es": "Este artículo es un breve resumen del famoso Mjölnir. Este símbolo también se usa en el logo de The Great Work Experience. Es un símbolo querido por todos los que aprecian y aman la Verdad.",
      "nl": "Dit artikel is een korte samenvatting van de beroemde Mjölnir. Dit symbool wordt ook gebruikt in het logo van The Great Work Experience. Het is een dierbaar symbool voor allen die de Waarheid koesteren en liefhebben.",
      "pap": "E artíkulo aki ta un resumen kòrtiku di e famoso Mjölnir. E símbolo aki ta wòrdu usá tambe den e logo di The Great Work Experience. E ta un símbolo stimá pa tur esnan ku ta apresiá i stima Bèrdat."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/Mjolnir-EN.pdf#toolbar=0",
      "es": "./articles/Mjolnir-ES.pdf#toolbar=0",
      "nl": "./articles/Mjolnir-NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/mjolnir.jpg",
    "imageAlt": "Mjölnir - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-2.html",
      "sourceLine": 233,
      "metaText": "By Eduard / 31 Dec 2021 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "This article is a little summary of the famous Mjölnir. This symbol is also used in the The Great Work Experience logo. It is a dear symbol for all those who cherish and love Truth.",
      "image": "images/mjolnir.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "the-case-for-graven-and-molten-images",
    "slug": {
      "en": "the-case-for-graven-and-molten-images",
      "es": "the-case-for-graven-and-molten-images",
      "nl": "the-case-for-graven-and-molten-images",
      "pap": "the-case-for-graven-and-molten-images"
    },
    "title": {
      "en": "The Case for Graven & Molten Images",
      "es": "El Caso de las Imágenes Talladas y Fundidas",
      "nl": "Het Pleidooi voor Gesneden & Gegoten Beelden",
      "pap": "E Argumento pa Imágennan Kòrtá i Fundí"
    },
    "author": "Eduard",
    "date": "2022-02-19",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "This article discusses the true reason behind the graven and molten images also described in the Bible. I have dedicated this article to Hypathia of Alexandria.",
      "es": "Este artículo expone la verdadera razón tras las imágenes talladas y fundidas que también describe la Biblia. He dedicado este artículo a Hipatia de Alejandría.",
      "nl": "Dit artikel bespreekt de ware reden achter de gesneden en gegoten beelden die ook in de Bijbel worden beschreven. Ik heb dit artikel opgedragen aan Hypatia van Alexandrië.",
      "pap": "E artíkulo aki ta papia di e berdadero motibu tras di e imágennan kòrtá i fundí ku tambe ta deskribí den Beibel. Mi a dediká e artíkulo aki na Hipatia di Alehandria."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/The Case For Graven Molten Images_EN.pdf#toolbar=0",
      "es": "./articles/The Case For Graven Molten Images_ES.pdf#toolbar=0",
      "nl": "./articles/The Case For Graven Molten Images_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/hypathia.jpg",
    "imageAlt": "The Case for Graven & Molten Images - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-2.html",
      "sourceLine": 247,
      "metaText": "By Eduard / 19 Feb 2022 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "This article discusses the true reason behind the graven and molten images also described in the Bible. I have dedicated this article to Hypathia of Alexandria.",
      "image": "images/hypathia.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "the-electric-logos",
    "slug": {
      "en": "the-electric-logos",
      "es": "the-electric-logos",
      "nl": "the-electric-logos",
      "pap": "the-electric-logos"
    },
    "title": {
      "en": "The Electric Logos",
      "es": "El Logos Eléctrico",
      "nl": "De Elektrische Logos",
      "pap": "E Logos Elektriko"
    },
    "author": "Eduard",
    "date": "2022-03-07",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "This article discusses the true essence of the Universe. It explores the ancient old idea of an electric universe.",
      "es": "Este artículo trata la verdadera esencia del Universo. Explora la antigua idea de un universo eléctrico.",
      "nl": "Dit artikel bespreekt de ware essentie van het Universum. Het verkent het eeuwenoude idee van een elektrisch universum.",
      "pap": "E artíkulo aki ta trata e berdadero esensia di e Universo. E ta eksplorá e idea antiguo di un universo elektriko."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/The Electric Logos_EN.pdf#toolbar=0",
      "es": "./articles/The Electric Logos_ES.pdf#toolbar=0",
      "nl": "./articles/The Electric Logos_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/thunder.png",
    "imageAlt": "The Electric Logos - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-2.html",
      "sourceLine": 261,
      "metaText": "By Eduard / 07 Mar 2022 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "This article discusses the true essence of the Universe. It explores the ancient old idea of an electric universe.",
      "image": "images/thunder.png"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "liber-555",
    "slug": {
      "en": "liber-555",
      "es": "liber-555",
      "nl": "liber-555",
      "pap": "liber-555"
    },
    "title": {
      "en": "Liber 555: Transitus ad Libertatem",
      "es": "Liber 555: Transitus ad Libertatem",
      "nl": "Liber 555: Transitus ad Libertatem",
      "pap": "Liber 555: Transitus ad Libertatem"
    },
    "author": "Eduard",
    "date": "2022-05-11",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "This is the The Great Work Experience Manifesto. A written statement advocating the pressing need to put freedom as a priority in our lives.",
      "es": "Este es el Manifiesto de The Great Work Experience. Una declaración escrita que defiende la urgente necesidad de poner la libertad como prioridad en nuestras vidas.",
      "nl": "Dit is het Manifest van The Great Work Experience. Een geschreven verklaring die pleit voor de dringende noodzaak om vrijheid tot prioriteit in ons leven te maken.",
      "pap": "Esaki ta e Manifesto di The Great Work Experience. Un deklarashon skirbí ku ta aboga pa e nesesidat urgente di pone libertat komo prioridat den nos bida."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/transitus-ad-libertatem-EN.pdf#toolbar=0",
      "es": "./articles/transitus-ad-libertatem-ES.pdf#toolbar=0",
      "nl": "./articles/transitus-ad-libertatem-NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/manifesto.jpg",
    "imageAlt": "Liber 555 - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-2.html",
      "sourceLine": 275,
      "metaText": "By Eduard / 11 May 2022 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "This is the The Great Work Experience Manifesto. A written statement advocating the pressing need to put freedom as a priority in our lives.",
      "image": "images/manifesto.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "the-sacred-gift-of-beauty",
    "slug": {
      "en": "the-sacred-gift-of-beauty",
      "es": "the-sacred-gift-of-beauty",
      "nl": "the-sacred-gift-of-beauty",
      "pap": "the-sacred-gift-of-beauty"
    },
    "title": {
      "en": "The Sacred Gift of Beauty",
      "es": "El Sagrado Don de la Belleza",
      "nl": "Het Heilige Geschenk van Schoonheid",
      "pap": "E Don Sagrado di Beyesa"
    },
    "author": "Eduard",
    "date": "2023-05-01",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "This article shed some unique and fresh light on the concept of Beauty, together with mercy and judgment, in the occult tradition.",
      "es": "Este artículo arroja una luz única y renovada sobre el concepto de la Belleza, junto con la misericordia y el juicio, en la tradición oculta.",
      "nl": "Dit artikel werpt een uniek en fris licht op het begrip Schoonheid, samen met genade en oordeel, in de occulte traditie.",
      "pap": "E artíkulo aki ta tira un lus úniko i fresku riba e konsepto di Beyesa, huntu ku miserikòrdia i huisio, den e tradishon okulto."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/the-sacred-gift-of-beauty_EN.pdf#toolbar=0",
      "es": "./articles/the-sacred-gift-of-beauty_ES.pdf#toolbar=0",
      "nl": "./articles/the-sacred-gift-of-beauty_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/beauty.jpeg",
    "imageAlt": "The Sacred Gift of Beauty - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-3.html",
      "sourceLine": 192,
      "metaText": "By Eduard / 01 May 2023 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "This article shed some unique and fresh light on the concept of Beauty, together with mercy and judgment, in the occult tradition.",
      "image": "images/beauty.jpeg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "sample-monograph-the-neteru",
    "slug": {
      "en": "sample-monograph-the-neteru",
      "es": "sample-monograph-the-neteru",
      "nl": "sample-monograph-the-neteru",
      "pap": "sample-monograph-the-neteru"
    },
    "title": {
      "en": "Sample Monograph: The Neteru",
      "es": "Monografía de Muestra: Los Neteru",
      "nl": "Voorbeeldmonografie: De Neteru",
      "pap": "Monografia di Muestra: E Neteru"
    },
    "author": "Tefnut Sekhem",
    "date": "2023-09-10",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "This serves as an introductory example of our monograph series, the initial installment made available free of charge to eager students. Subsequent monographs are distributed on a monthly basis to our members and supporters. You can gain access to these insightful monographs by contributing just EUR 33 per month, which grants you the privilege of membership. Please note that the monographs are not an entitlement but a special benefit. To join our community and start receiving these monthly monographs, you can become a member by visiting our membership page at https://thegreatworkexperience.com/donate Alternatively, you can reach out to us via email at info@thegreatworkexperience.com to express your interest and request more details.",
      "es": "Esto sirve como ejemplo introductorio de nuestra serie de monografías, la primera entrega ofrecida de forma gratuita a los estudiantes interesados. Las monografías siguientes se distribuyen mensualmente a nuestros miembros y colaboradores. Puedes acceder a estas valiosas monografías contribuyendo solo EUR 33 al mes, lo que te otorga el privilegio de la membresía. Ten en cuenta que las monografías no son un derecho, sino un beneficio especial. Para unirte a nuestra comunidad y empezar a recibir estas monografías mensuales, puedes hacerte miembro visitando nuestra página de membresía en https://thegreatworkexperience.com/donate También puedes escribirnos por correo a info@thegreatworkexperience.com para expresar tu interés y solicitar más detalles.",
      "nl": "Dit dient als inleidend voorbeeld van onze monografieënreeks, de eerste aflevering die gratis beschikbaar wordt gesteld aan gretige studenten. Volgende monografieën worden maandelijks verspreid onder onze leden en steuners. Je krijgt toegang tot deze inzichtelijke monografieën door slechts EUR 33 per maand bij te dragen, wat je het voorrecht van lidmaatschap geeft. Let op: de monografieën zijn geen recht maar een bijzonder voordeel. Om lid te worden van onze gemeenschap en deze maandelijkse monografieën te ontvangen, kun je lid worden via onze lidmaatschapspagina op https://thegreatworkexperience.com/donate Je kunt ons ook mailen op info@thegreatworkexperience.com om je interesse kenbaar te maken en meer details te vragen.",
      "pap": "Esaki ta sirbi komo un ehèmpel introduktorio di nos seri di monografíanan, e promé entrega ofresí grátis na studiantenan interesá. E monografíanan siguiente ta wòrdu distribuí kada luna na nos miembronan i sostenedónan. Bo por haña akseso na e monografíanan balioso aki dor di kontribuí solamente EUR 33 pa luna, loke ta duna bo e privilegio di mèmbresia. Tene kuenta ku e monografíanan no ta un derecho sino un benefisio spesial. Pa bira parti di nos komunidat i kuminsá risibí e monografíanan mensual aki, bo por bira miembro via nos página di mèmbresia na https://thegreatworkexperience.com/donate Of bo por kontaktá nos via email na info@thegreatworkexperience.com pa mustra bo interes i pidi mas detaye."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/first-element-the-neteru-EN.pdf#toolbar=0",
      "es": "./articles/first-element-the-neteru-ES.pdf#toolbar=0",
      "nl": "./articles/first-element-the-neteru-NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/neteru-ra.jpeg",
    "imageAlt": "Sample Monograph: The Neteru - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-3.html",
      "sourceLine": 206,
      "metaText": "By Tefnut Sekhem / 10 Sep 2023 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "This serves as an introductory example of our monograph series, the initial installment made available free of charge to eager students. Subsequent monographs are distributed on a monthly basis to our members and supporters. You can gain access to these insightful monographs by contributing just EUR 33 per month, which grants you the privilege of membership. Please note that the monographs are not an entitlement but a special benefit. To join our community and start receiving these monthly monographs, you can become a member by visiting our membership page at https://thegreatworkexperience.com/donate Alternatively, you can reach out to us via email at info@thegreatworkexperience.com to express your interest and request more details.",
      "image": "images/neteru-ra.jpeg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "the-codex-of-eternity-from-the-djd-waw-the-first-speech",
    "slug": {
      "en": "the-codex-of-eternity-from-the-djd-waw-the-first-speech",
      "es": "the-codex-of-eternity-from-the-djd-waw-the-first-speech",
      "nl": "the-codex-of-eternity-from-the-djd-waw-the-first-speech",
      "pap": "the-codex-of-eternity-from-the-djd-waw-the-first-speech"
    },
    "title": {
      "en": "The Codex of Eternity: From the Djd Waw – The First Speech",
      "es": "The Codex of Eternity: Del Djd Waw – El Primer Discurso",
      "nl": "The Codex of Eternity: Uit de Djd Waw – De Eerste Toespraak",
      "pap": "The Codex of Eternity: For di e Djd Waw – E Promé Diskurso"
    },
    "author": "Tefnut Sekhem",
    "date": "2024-01-20",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "This is the first letter given to all who begin their journey with my Tarot Master Class, the path of transformation. The *Codex of Eternity* (attached) marks your first step into the timeless wisdom of Tarot. Here, Tarot is not merely a tool, but a living force guiding the ascent of your soul. Enjoy this sacred text and let its mysteries unfold before you. To join our community and start receiving these monthly monographs, you can become a member by visiting our membership page at https://thegreatworkexperience.com/donate Alternatively, you can reach out to us via email at info@thegreatworkexperience.com to express your interest and request more details.",
      "es": "Esta es la primera carta entregada a todos los que comienzan su viaje con mi Tarot Master Class: el camino de la transformación. El *Codex of Eternity* (adjunto) marca tu primer paso hacia la sabiduría atemporal del Tarot. Aquí, el Tarot no es solo una herramienta, sino una fuerza viva que guía el ascenso de tu alma. Disfruta este texto sagrado y deja que sus misterios se revelen ante ti. Para unirte a nuestra comunidad y empezar a recibir estas monografías mensuales, puedes hacerte miembro visitando nuestra página de membresía en https://thegreatworkexperience.com/donate También puedes escribirnos por correo a info@thegreatworkexperience.com para expresar tu interés y solicitar más detalles.",
      "nl": "Dit is de eerste brief die wordt gegeven aan allen die hun reis beginnen met mijn Tarot Master Class, het pad van transformatie. De *Codex of Eternity* (bijgevoegd) markeert je eerste stap in de tijdloze wijsheid van Tarot. Hier is Tarot niet slechts een hulpmiddel, maar een levende kracht die de opgang van je ziel begeleidt. Geniet van deze heilige tekst en laat haar mysteriën zich voor je ontvouwen. Om lid te worden van onze gemeenschap en deze maandelijkse monografieën te ontvangen, kun je lid worden via onze lidmaatschapspagina op https://thegreatworkexperience.com/donate Je kunt ons ook mailen op info@thegreatworkexperience.com om je interesse kenbaar te maken en meer details te vragen.",
      "pap": "Esaki ta e promé karta ku ta wòrdu duná na tur esnan ku ta kuminsá nan biahe ku mi Tarot Master Class, e kaminda di transformashon. E *Codex of Eternity* (adhuntá) ta marka bo promé paso den e sabiduria sin tempu di Tarot. Akinan, Tarot no ta solamente un hèrmènt, sino un forsa bibu ku ta guia e subida di bo alma. Gosa di e teksto sagrado aki i laga su misterionan despleg dilanti di bo. Pa bira parti di nos komunidat i kuminsá risibí e monografíanan mensual aki, bo por bira miembro via nos página di mèmbresia na https://thegreatworkexperience.com/donate Of bo por kontaktá nos via email na info@thegreatworkexperience.com pa mustra bo interes i pidi mas detaye."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/Shfdw Tawrt - 0. Codex of Eternity-EN.pdf#toolbar=0",
      "es": "./articles/Shfdw Tawrt - 0. Codex of Eternity-ES.pdf",
      "nl": "./articles/Shfdw Tawrt - 0. Codex of Eternity-NL.pdf",
      "pap": null
    },
    "image": "/assets/images/last-supper-2.jpg",
    "imageAlt": "The Codex of Eternity: From the Djd Waw – The First Speech - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-3.html",
      "sourceLine": 222,
      "metaText": "By Tefnut Sekhem / 20 Jan 2024 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "This is the first letter given to all who begin their journey with my Tarot Master Class, the path of transformation. The *Codex of Eternity* (attached) marks your first step into the timeless wisdom of Tarot. Here, Tarot is not merely a tool, but a living force guiding the ascent of your soul. Enjoy this sacred text and let its mysteries unfold before you. To join our community and start receiving these monthly monographs, you can become a member by visiting our membership page at https://thegreatworkexperience.com/donate Alternatively, you can reach out to us via email at info@thegreatworkexperience.com to express your interest and request more details.",
      "image": "images/last-supper-2.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "understanding-law-there-are-no-human-laws-only-eternal-principles-governing-reality",
    "slug": {
      "en": "understanding-law-there-are-no-human-laws-only-eternal-principles-govern",
      "es": "understanding-law-there-are-no-human-laws-only-eternal-principles-govern",
      "nl": "understanding-law-there-are-no-human-laws-only-eternal-principles-govern",
      "pap": "understanding-law-there-are-no-human-laws-only-eternal-principles-govern"
    },
    "title": {
      "en": "Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality",
      "es": "Entender la Ley: No Existen Leyes Humanas, Solo Principios Eternos que Rigen la Realidad",
      "nl": "De Wet Begrijpen: Er Zijn Geen Menselijke Wetten, Alleen Eeuwige Principes die de Werkelijkheid Besturen",
      "pap": "Komprondé Lei: No Tin Lei Humano, Solamente Prinsipionan Eterno ku ta Goberná Realidat"
    },
    "author": "Tefnut Sekhem",
    "date": "2026-01-07",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "The universe is sustained by immutable laws. Not by belief, not by worship, and not by the decrees of men. Those who align with these laws endure; those who violate them are corrected by consequence.",
      "es": "El universo se sostiene por leyes inmutables. No por la creencia, ni por el culto, ni por los decretos de los hombres. Quienes se alinean con estas leyes perduran; quienes las violan son corregidos por la consecuencia.",
      "nl": "Het universum wordt in stand gehouden door onveranderlijke wetten. Niet door geloof, niet door verering en niet door de decreten van mensen. Wie zich met deze wetten verbindt, houdt stand; wie ze overtreedt, wordt door de gevolgen gecorrigeerd.",
      "pap": "E universo ta wòrdu sostené pa leinan inmutabel. No pa kreensia, no pa adorashon, i no pa e dekretonan di hende. Esnan ku ta alineá ku e leinan aki ta perdurá; esnan ku ta violá nan ta wòrdu korigí pa konsekuensia."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/understanding-law-EN.pdf#toolbar=0",
      "es": "./articles/understanding-law-ES.pdf",
      "nl": "./articles/understanding-law-NL.pdf",
      "pap": null
    },
    "image": "/assets/images/maat-1.png",
    "imageAlt": "Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles-3.html",
      "sourceLine": 241,
      "metaText": "By Tefnut Sekhem / 7 Jan 2026 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "The universe is sustained by immutable laws. Not by belief, not by worship, and not by the decrees of men. Those who align with these laws endure; those who violate them are corrected by consequence.",
      "image": "images/maat-1.png"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "freedom-the-divine-elixir-of-harmony",
    "slug": {
      "en": "freedom-the-divine-elixir-of-harmony",
      "es": "freedom-the-divine-elixir-of-harmony",
      "nl": "freedom-the-divine-elixir-of-harmony",
      "pap": "freedom-the-divine-elixir-of-harmony"
    },
    "title": {
      "en": "Freedom - The Divine Elixir of Harmony",
      "es": "Libertad - El Divino Elixir de la Armonía",
      "nl": "Vrijheid - Het Goddelijke Elixir van Harmonie",
      "pap": "Libertat - E Eliksir Divino di Armonia"
    },
    "author": "Eduard",
    "date": "2020-02-08",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "In this article, the true essence of Freedom is discussed in relation to a Harmonious living with the whole Earth.",
      "es": "En este artículo se analiza la verdadera esencia de la Libertad en relación con una convivencia armoniosa con toda la Tierra.",
      "nl": "In dit artikel wordt de ware essentie van Vrijheid besproken in relatie tot een harmonieus samenleven met de hele Aarde.",
      "pap": "Den e artíkulo aki ta papia di e berdadero esensia di Libertat den relashon ku un bida armonioso ku henter e Tera."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/Freedom - the divine exilir of harmonyv3.pdf#toolbar=0",
      "es": "./articles/Freedom - the divine exilir of harmonyv3_ES.pdf#toolbar=0",
      "nl": "./articles/Freedom - the divine exilir of harmonyv3_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/freedom.jpg",
    "imageAlt": "Freedom - The Divine Elixir of Harmony - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles.html",
      "sourceLine": 191,
      "metaText": "By Eduard / 08 February 2020 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "In this article, the true essence of Freedom is discussed in relation to a Harmonious living with the whole Earth.",
      "image": "images/freedom.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "lord-of-the-elements-son-of-the-sun",
    "slug": {
      "en": "lord-of-the-elements-son-of-the-sun",
      "es": "lord-of-the-elements-son-of-the-sun",
      "nl": "lord-of-the-elements-son-of-the-sun",
      "pap": "lord-of-the-elements-son-of-the-sun"
    },
    "title": {
      "en": "Lord of the Elements - Son of the Sun",
      "es": "Señor de los Elementos - Hijo del Sol",
      "nl": "Heer van de Elementen - Zoon van de Zon",
      "pap": "Señor di e Elementonan - Yu di Solo"
    },
    "author": "Eduard",
    "date": "2020-07-12",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "In this article, the true source of power is discussed in relation to the four elements. The proposed concept is based on the Western Schools of Thought which can be also easily understood if accustomed to learn based on the Eastern Schools of Thought.",
      "es": "En este artículo se analiza la verdadera fuente del poder en relación con los cuatro elementos. El concepto propuesto se basa en las Escuelas de Pensamiento Occidentales, que también se comprenden con facilidad si se está acostumbrado a aprender según las Escuelas de Pensamiento Orientales.",
      "nl": "In dit artikel wordt de ware bron van kracht besproken in relatie tot de vier elementen. Het voorgestelde concept is gebaseerd op de westerse denkscholen en is ook goed te begrijpen voor wie gewend is te leren vanuit de oosterse denkscholen.",
      "pap": "Den e artíkulo aki ta papia di e berdadero fuente di poder den relashon ku e kuater elementonan. E konsepto proponé ta basá riba e Skolnan di Pensamentu Western, ku tambe ta fásil di komprondé si bo ta kustumbrá siña basá riba e Skolnan di Pensamentu Oriental."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/Lord of the Elements - Son of the Sunv3.pdf#toolbar=0",
      "es": "./articles/Lord of the Elements - Son of the Sunv3_ES.pdf#toolbar=0",
      "nl": "./articles/Lord of the Elements - Son of the Sunv3_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/elements.jpg",
    "imageAlt": "Lord of the Elements - Son of the Sun - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles.html",
      "sourceLine": 205,
      "metaText": "By Eduard / 12 July 2020 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "In this article, the true source of power is discussed in relation to the four elements. The proposed concept is based on the Western Schools of Thought which can be also easily understood if accustomed to learn based on the Eastern Schools of Thought.",
      "image": "images/elements.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "the-suppression-of-the-divine-feminine-force",
    "slug": {
      "en": "the-suppression-of-the-divine-feminine-force",
      "es": "the-suppression-of-the-divine-feminine-force",
      "nl": "the-suppression-of-the-divine-feminine-force",
      "pap": "the-suppression-of-the-divine-feminine-force"
    },
    "title": {
      "en": "The Suppression of the Divine Feminine Force",
      "es": "La Supresión de la Fuerza Femenina Divina",
      "nl": "De Onderdrukking van de Goddelijke Vrouwelijke Kracht",
      "pap": "E Supreshon di e Forsa Femenino Divino"
    },
    "author": "Eduard",
    "date": "2020-05-05",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "In this article, feminism is being addressed in an intresting yet revealing way. The article presents true Feminism compared to the false believes of today.",
      "es": "En este artículo se aborda el feminismo de una manera interesante y reveladora. El artículo presenta el verdadero Feminismo frente a las falsas creencias de hoy.",
      "nl": "In dit artikel wordt feminisme op een interessante en onthullende manier behandeld. Het artikel presenteert het ware Feminisme tegenover de valse opvattingen van vandaag.",
      "pap": "Den e artíkulo aki ta trata feminismo na un manera interesante i reveladó. E artíkulo ta presentá e berdadero Feminismo kompará ku e kreensianan falsu di awe."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/The Suppression of the Divine Feminine Forcev3.pdf#toolbar=0",
      "es": "./articles/The Suppression of the Divine Feminine Forcev3_ES.pdf#toolbar=0",
      "nl": "./articles/The Suppression of the Divine Feminine Forcev3_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/feminism.jpg",
    "imageAlt": "The Suppression of the Divine Feminine Force - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles.html",
      "sourceLine": 219,
      "metaText": "By Eduard / 05 May 2020 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "In this article, feminism is being addressed in an intresting yet revealing way. The article presents true Feminism compared to the false believes of today.",
      "image": "images/feminism.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "on-the-purpose-of-humanity-on-earth",
    "slug": {
      "en": "on-the-purpose-of-humanity-on-earth",
      "es": "on-the-purpose-of-humanity-on-earth",
      "nl": "on-the-purpose-of-humanity-on-earth",
      "pap": "on-the-purpose-of-humanity-on-earth"
    },
    "title": {
      "en": "On the Purpose of Humanity on Earth",
      "es": "Sobre el Propósito de la Humanidad en la Tierra",
      "nl": "Over het Doel van de Mensheid op Aarde",
      "pap": "Tokante e Propósito di Humanidat riba Tera"
    },
    "author": "Eduard",
    "date": "2020-11-15",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "This article dives into the true purpose of the human race in relation to the Creation. The wise contemplate carefully on these subjects, while the folly live his/her life just to die another day.",
      "es": "Este artículo profundiza en el verdadero propósito de la humanidad en relación con la Creación. Los sabios reflexionan con cuidado sobre estos temas, mientras que los necios viven su vida solo para morir un día más.",
      "nl": "Dit artikel gaat in op het ware doel van de mensheid in relatie tot de Schepping. De wijzen overdenken deze onderwerpen zorgvuldig, terwijl de dwazen hun leven leven slechts om weer een dag te sterven.",
      "pap": "E artíkulo aki ta profundisá den e berdadero propósito di humanidat den relashon ku e Kreashon. E sabionan ta kontemplá ku kuidou riba e tópikonan aki, miéntras e bobonan ta biba nan bida djis pa muri un otro dia."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/On the Purpose of Humanity on Earth.pdf#toolbar=0",
      "es": "./articles/On the Purpose of Humanity On Earth_ES.pdf#toolbar=0",
      "nl": "./articles/On the Purpose of Humanity On Earth_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/purpose.jpg",
    "imageAlt": "On the Purpose of Humanity on Earth - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles.html",
      "sourceLine": 233,
      "metaText": "By Eduard / 15 November 2020 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "This article dives into the true purpose of the human race in relation to the Creation. The wise contemplate carefully on these subjects, while the folly live his/her life just to die another day.",
      "image": "images/purpose.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "the-states-of-consciousness-in-the-evolution-of-men",
    "slug": {
      "en": "the-states-of-consciousness-in-the-evolution-of-men",
      "es": "the-states-of-consciousness-in-the-evolution-of-men",
      "nl": "the-states-of-consciousness-in-the-evolution-of-men",
      "pap": "the-states-of-consciousness-in-the-evolution-of-men"
    },
    "title": {
      "en": "The States of Consciousness in the Evolution of Men",
      "es": "Los Estados de Conciencia en la Evolución del Hombre",
      "nl": "De Bewustzijnstoestanden in de Evolutie van de Mens",
      "pap": "E Estadonan di Konsenshi den e Evolushon di Hende"
    },
    "author": "Eduard",
    "date": "2020-12-12",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "In this article, the 7 States of Consciousness is being discussed. The characters of each are also discussed. It conveys the idea of Conscious Evolution, the idea that true evolution only happens consciously.",
      "es": "En este artículo se analizan los 7 Estados de Conciencia. También se examinan las características de cada uno. Transmite la idea de la Evolución Consciente: que la verdadera evolución solo ocurre de manera consciente.",
      "nl": "In dit artikel worden de 7 Bewustzijnstoestanden besproken. Ook de kenmerken van elk komen aan bod. Het brengt het idee van Bewuste Evolutie over: dat ware evolutie alleen bewust plaatsvindt.",
      "pap": "Den e artíkulo aki ta papia di e 7 Estadonan di Konsenshi. Tambe ta trata e karakteristikanan di kada un. E ta transmití e idea di Evolushon Konsiente: ku berdadero evolushon ta sosodé solamente konsientemente."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/The States Of Consciousness-1177.pdf#toolbar=0",
      "es": "./articles/The States Of Consciousness-1177_ES.pdf#toolbar=0",
      "nl": "./articles/The States Of Consciousness-1177_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/consciousness.jpg",
    "imageAlt": "The States of Consciousness in the Evolution of Men - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles.html",
      "sourceLine": 247,
      "metaText": "By Eduard / 12 December 2020 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "In this article, the 7 States of Consciousness is being discussed. The characters of each are also discussed. It conveys the idea of Conscious Evolution, the idea that true evolution only happens consciously.",
      "image": "images/consciousness.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "a-small-discourse-on-the-immutability-of-natural-laws",
    "slug": {
      "en": "a-small-discourse-on-the-immutability-of-natural-laws",
      "es": "a-small-discourse-on-the-immutability-of-natural-laws",
      "nl": "a-small-discourse-on-the-immutability-of-natural-laws",
      "pap": "a-small-discourse-on-the-immutability-of-natural-laws"
    },
    "title": {
      "en": "A Small Discourse on the Immutability of Natural Laws",
      "es": "Un Pequeño Discurso sobre la Inmutabilidad de las Leyes Naturales",
      "nl": "Een Klein Betoog over de Onveranderlijkheid van Natuurwetten",
      "pap": "Un Diskurso Chikitu tokante e Inmutabilidat di Leinan Natural"
    },
    "author": "Eduard",
    "date": "2021-01-05",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "In this article, the mutability of Natural Laws is being discussed. The idea of how this can be possible is addressed. It plays with the idea of the Divine, at each cycle, decides what to experience. Based on these, the \"rules of the game\" is eminated so to speak, creating with each cycle a set of Natural Laws that are specific for the new experience.",
      "es": "En este artículo se analiza la mutabilidad de las Leyes Naturales. Se aborda la cuestión de cómo esto puede ser posible. Juega con la idea de que lo Divino, en cada ciclo, decide qué experimentar. A partir de ello emanan, por así decirlo, las \"reglas del juego\", creando en cada ciclo un conjunto de Leyes Naturales específicas para la nueva experiencia.",
      "nl": "In dit artikel wordt de veranderlijkheid van de Natuurwetten besproken. De vraag hoe dit mogelijk is, komt aan bod. Het speelt met het idee dat het Goddelijke bij elke cyclus beslist wat het wil ervaren. Daaruit vloeien als het ware de \"spelregels\" voort, waardoor bij elke cyclus een set Natuurwetten ontstaat die specifiek is voor de nieuwe ervaring.",
      "pap": "Den e artíkulo aki ta papia di e mutabilidat di e Leinan Natural. Ta trata e idea di kon esaki por ta posibel. E ta hunga ku e idea ku e Divino, na kada siklo, ta disidí kiko e ke eksperensiá. Basá riba esaki, e \"reglanan di e wega\" ta emaná, por asina bisa, kreando na kada siklo un set di Leinan Natural spesífiko pa e nobo eksperensia."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/A Discourse on the Immutability of Natural Laws.pdf#toolbar=0",
      "es": "./articles/A Discourse on the Immutability of Natural Laws_ES.pdf#toolbar=0",
      "nl": "./articles/A Discourse on the Immutability of Natural Laws_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/scale.jpeg",
    "imageAlt": "A Small Discourse on the Immutability of Natural Laws - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles.html",
      "sourceLine": 261,
      "metaText": "By Eduard / 05 Januari 2021 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "In this article, the mutability of Natural Laws is being discussed. The idea of how this can be possible is addressed. It plays with the idea of the Divine, at each cycle, decides what to experience. Based on these, the \"rules of the game\" is eminated so to speak, creating with each cycle a set of Natural Laws that are specific for the new experience.",
      "image": "images/scale.jpeg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  },
  {
    "id": "on-the-purpose-of-humanity-in-the-universe",
    "slug": {
      "en": "on-the-purpose-of-humanity-in-the-universe",
      "es": "on-the-purpose-of-humanity-in-the-universe",
      "nl": "on-the-purpose-of-humanity-in-the-universe",
      "pap": "on-the-purpose-of-humanity-in-the-universe"
    },
    "title": {
      "en": "On the Purpose of Humanity in the Universe",
      "es": "Sobre el Propósito de la Humanidad en el Universo",
      "nl": "Over het Doel van de Mensheid in het Universum",
      "pap": "Tokante e Propósito di Humanidat den e Universo"
    },
    "author": "Eduard",
    "date": "2021-02-04",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "summary": {
      "en": "In this article, we will discuss some intresting parallel between Biblical stories, and the work of Zecharia Sitchin. It is an idea worth exploring, considering that the Bible is an extended account of the beings Sitchin is talking about.",
      "es": "En este artículo analizaremos algunos paralelismos interesantes entre los relatos bíblicos y la obra de Zecharia Sitchin. Es una idea que vale la pena explorar, considerando que la Biblia es un relato extendido de los seres de los que habla Sitchin.",
      "nl": "In dit artikel bespreken we enkele interessante parallellen tussen Bijbelse verhalen en het werk van Zecharia Sitchin. Het is een idee dat het verkennen waard is, aangezien de Bijbel een uitgebreid verslag is van de wezens waarover Sitchin spreekt.",
      "pap": "Den e artíkulo aki nos lo papia di algun paralelo interesante entre historianan Bíbliko i e trabou di Zecharia Sitchin. Ta un idea ku bal la pena eksplorá, konsiderando ku Beibel ta un relato ekstendí di e sernan ku Sitchin ta papia."
    },
    "body": null,
    "pdfLinks": {
      "en": "./articles/On The Purpose of Humanity in the Universe.pdf#toolbar=0",
      "es": "./articles/On The Purpose of Humanity in the Universe_ES.pdf#toolbar=0",
      "nl": "./articles/On The Purpose of Humanity in the Universe_NL.pdf#toolbar=0",
      "pap": null
    },
    "image": "/assets/images/human-universe.jpg",
    "imageAlt": "On the Purpose of Humanity in the Universe - article image from the The Great Work Experience archive",
    "legacy": {
      "sourcePage": "articles.html",
      "sourceLine": 280,
      "metaText": "By Eduard / 04 February 2021 / related book: Anarkhos | EN | ES | NL |",
      "blurb": "In this article, we will discuss some intresting parallel between Biblical stories, and the work of Zecharia Sitchin. It is an idea worth exploring, considering that the Bible is an extended account of the beings Sitchin is talking about.",
      "image": "images/human-universe.jpg"
    },
    "relatedPrograms": [],
    "relatedEpisodes": [],
    "relatedCourses": [],
    "tags": [
      "legacy-article",
      "phase-2-source-backed"
    ]
  }
];
